import { Controller } from "@hotwired/stimulus"

// Opens the <details> element addressed by the URL fragment (e.g. /faqs#some-slug), so a deep link
// shows the answer instead of only scrolling to a collapsed question. The browser (or Turbo) still
// does the scrolling; this only flips `open`, on connect and whenever the fragment changes.
//
// Connects to data-controller="linked-details"
export default class extends Controller {
  connect() {
    this.openLinkedDetails()
    window.addEventListener("hashchange", this.openLinkedDetails)
  }

  disconnect() {
    window.removeEventListener("hashchange", this.openLinkedDetails)
  }

  openLinkedDetails = () => {
    const id = decodeURIComponent(window.location.hash.slice(1))
    if (!id) return
    const details = this.element.querySelector(`#${CSS.escape(id)}`)?.closest("details")
    if (details) details.open = true
  }
}
